"use client";

import React from "react";
import { Box, Tabs, Tab, Button } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { formatTitle, DOCUMENT_TYPES } from "../utils/venue.utils";

interface VenueHeaderProps {
  activeTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  onEditClick: () => void;
  primaryColor: string;
}

export const VenueHeader: React.FC<VenueHeaderProps> = ({
  activeTab,
  onTabChange,
  onEditClick,
  primaryColor,
}) => {
  return (
    <Box
      sx={{
        mb: 4,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "primary.main",
          },
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: "medium",
            fontSize: "1rem",
            "&.Mui-selected": {
              color: "primary.main",
            },
          },
        }}
      >
        <Tab label="Venue Details" />
        {DOCUMENT_TYPES.map((docType) => (
          <Tab key={docType} label={formatTitle(docType)} />
        ))}
        <Tab label="Venue Layout" />
      </Tabs>

      <Button
        variant="outlined"
        startIcon={<EditIcon />}
        sx={{
          border: `2px solid ${primaryColor}`,
          color: primaryColor,
        }}
        onClick={onEditClick}
      >
        Edit
      </Button>
    </Box>
  );
};

export default VenueHeader;
